import { Box, Text, Button, Stack, styled } from '@ltvco/refresh-lib/theme';

export const PopoverContainer = styled(Box)(({ theme }) => ({
  width: '340px',
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.down('sm')]: {
    width: '100vw',
    maxWidth: '100vw',
  },
}));

export const Header = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(2, 2.5),
  borderBottom: `1px solid ${theme.palette.divider}`,
}));

export const Title = styled(Text)(() => ({
  fontWeight: 600,
  fontSize: '1.125rem',
}));

export const ContentBody = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2.5),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2.5),
}));

export const FieldContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const FieldLabel = styled(Text)(({ theme }) => ({
  fontSize: '0.875rem',
  fontWeight: 500,
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(0.75),
}));

export const selectStyles = {
  backgroundColor: 'common.white',
  borderRadius: '8px',
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'divider',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: 'primary.main',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: 'primary.main',
    borderWidth: '1px',
  },
  '& .MuiSelect-select': {
    padding: '10px 14px',
    fontSize: '0.875rem',
  },
};

export const inputStyles = {
  backgroundColor: 'common.white',
  borderRadius: '8px',
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'divider',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    borderColor: 'primary.main',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: 'primary.main',
    borderWidth: '1px',
  },
  '& .MuiInputBase-input': {
    padding: '10px 14px',
    fontSize: '0.875rem',
  },
};

export const Footer = styled(Stack)(({ theme }) => ({
  flexDirection: 'column',
  gap: theme.spacing(1),
  padding: theme.spacing(0, 2.5, 2.5, 2.5),
}));

export const ApplyButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  fontWeight: 600,
  borderRadius: '24px',
  padding: theme.spacing(1.25, 3),
  width: '100%',
}));

export const CancelButton = styled(Button)(({ theme }) => ({
  textTransform: 'none',
  fontWeight: 500,
  borderRadius: '24px',
  padding: theme.spacing(1.25, 3),
  width: '100%',
  borderColor: theme.palette.divider,
  color: theme.palette.primary.main,
}));
